export default __webpack_public_path__ + "static/compareItemImg5-c8ff8de17ce3aca8d16651bf54ffea99.webp";